import { DatePicker } from "@mui/x-date-pickers";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { TextField } from "@mui/material";
import { useEffect, useState } from "react";

import { useTranslation } from "react-i18next";

export default function CustomAlertStep1(
    props: CustomAlertPropsTypes
) {
    const { t } = useTranslation();

    const [datCarregamento, setDatCarregamento] = useState<Date>(new Date());

    const onChange = (value: string) => {
        if (value.length == 10) {
            setDatCarregamento(new Date(value))
        }
    }

    return (
        <div className="react-confirm-alert-body">
            <h1>{t("common.warning")}</h1>
            {t("pages.finishiedProduct.text.wantProceed2")}<br /><br />

            <br />
            <div style={{ width: '180px' }}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                        label={`${t("common.expectedDeliveryDate")}*`}
                        value={datCarregamento}
                        onChange={(newValue: any) => {
                            if (newValue != 'Invalid Date') {
                                setDatCarregamento(newValue);
                            }
                        }}
                        inputFormat="dd/MM/yyyy"
                        renderInput={(params: any) => (
                            <TextField
                                {...params}
                                size="small"
                                onChange={(event) => { onChange(event.target.value) }}
                            />
                        )}
                    />
                </LocalizationProvider>
            </div><br />
            <small><b>*</b>{t("pages.finishiedProduct.text.wantProccedClickYes")}</small>
            <div className="react-confirm-alert-button-group">
                <button onClick={() => props.onClickYes(datCarregamento)}>{t("common.yes")}</button>
                <button onClick={props.onClose}>{t("common.no")}</button>
            </div>
        </div>
    );
}

interface CustomAlertPropsTypes {
    onClose: any;
    onClickYes: any;
}
